export default __webpack_public_path__ + "static/media/slack.6211aed8.png";